// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"9113029a","79":"d3857bc6","286":"2d4757eb","429":"22f94eca","482":"696532fb","808":"5c353119","871":"e352440a"}[chunkId] + ".chunk.js";
};